module.exports = __webpack_public_path__ + "img/adulto-mayor.1b44c6eb.png";